import {
    Button,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Typography,
} from '@mui/material';
import type { ReactNode } from 'react';

import useTranslate from 'hooks/useTranslate';

interface Props {
    title: string;
    content: ReactNode | string;
    loading?: boolean;
    onClose: () => void;
    onConfirm: () => void | Promise<void>;
}

const ConfirmationDialog = ({ title, content, loading, onClose, onConfirm }: Props) => {
    const { translate } = useTranslate();

    return (
        <Dialog open fullWidth maxWidth="xs">
            <DialogTitle>{title}</DialogTitle>
            <DialogContent>
                {typeof content === 'string' ? (
                    <Typography variant="body2" color="text.secondary">
                        {content}
                    </Typography>
                ) : (
                    content
                )}
            </DialogContent>

            <DialogActions sx={{ px: 3, pb: 3 }}>
                <Button variant="outlined" onClick={onClose} disabled={loading}>
                    {translate('cancel')}
                </Button>
                <Button
                    variant="contained"
                    onClick={onConfirm}
                    disabled={loading}
                    startIcon={loading ? <CircularProgress size={16} color="inherit" /> : undefined}
                >
                    {translate('confirm')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmationDialog;
